import { AbstractValidator } from "./AbstractValidator";
import { IValidator } from "./IValidator";
import { AbstractControl, ValidationErrors } from "@angular/forms";

import * as moment from 'moment';

import { Yii } from "libraries/interfaces/Yii";

export class IsPast extends AbstractValidator implements IValidator {
    public constructor() {
        super({
            isPast: {
                when: 'touched',
                class: 'form-error-date',
                message: Yii.t('wui-shared-js', 'La valeur saisie ne peut se situer dans le futur'),
            },
        });
    }

    public validate(control: AbstractControl): ValidationErrors | null {
        if (!control.value) {
            return null;
        }

        const dateValue: moment.Moment = moment(control.value);
        const today: moment.Moment = moment();

        return dateValue.isAfter(today) ? { isPast: control.value } : null;
    }
}